function getFullImageUrl(imagePath) {
    return (`${process.env.STRAPI_API_URL}${imagePath}`);
}

function buildRefToFooter(footerId) {
    return (`#${footerId}`)
}

function buildFooterOriginId(footerId) {
    return (`origin_${footerId}`)
}

function buildRefToFooterOrigin(footerId) {
    return (`#${buildFooterOriginId(footerId)}`)
}

function buildTestimonialId(testimonialId) {
    return (`testimonial_${testimonialId}`)
}

function buildRefToTestimonial(testimonialId, testimonialsPageSlug) {
    return (`${testimonialsPageSlug}/#${buildTestimonialId(testimonialId)}`)
}

function joinClassNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

function getHref (link, language){
    if (link === null) {
        return '';
    }

    if (link?.ExternalURL) {
        return link.ExternalURL;
    }

    let internalLink = "";
    if (link.Page != null && link.Page.Slug != null){
        internalLink = `/${language}/${link.Page.Slug}`;
    } else {
        internalLink = `/${language}/blog/${link.BlogArticle.Slug}`;
    }

    if(link.SectionId != null){
        return `${internalLink}#${link.SectionId}`;
    }
    return internalLink;
}

const getStaticPath = (url) => {
    if (!url) return '';
    const filename = url.split('/').pop();
    return `/uploads/${filename}`;
};

module.exports = {
    getFullImageUrl,
    buildRefToFooter,
    buildFooterOriginId,
    buildRefToFooterOrigin,
    buildTestimonialId,
    buildRefToTestimonial,
    joinClassNames,
    getHref,
    getStaticPath
};